import { useQuery } from '@tanstack/react-query';
import { roomAdApi } from '../api/roomAd.api';
import { roomAdKeys } from '../api/roomAd.keys';

export function useRoomAdDetails(id: any) {
  return useQuery({
    queryKey: roomAdKeys.detail(id),
    queryFn: () => roomAdApi.getById(id),
    enabled: !!id,
  });
}
